import breakPoints from 'helpers/Styles';
import Link from 'next/link';

const AuxBanner = ({ block }) => {
  if (!block) return '';
  const { primary } = block;
  const title = primary?.title1 ? primary.title1 : null;
  const titleColour = primary?.title1_colour
    ? primary.title1_colour
    : '#e4e4e4';
  const description = primary?.description ? primary.description : null;
  const descriptionColour = primary?.description_colour
    ? primary.description_colour
    : '#e4e4e4';
  const imageUrl = primary.image ? primary.image.url : null;
  const imageMobile = primary.image_mobile ? primary.image_mobile.url : null;
  const buttonTexts = primary?.button_texts ? primary.button_texts : null;
  const buttonTextsColour = primary?.button_texts_colour
    ? primary.button_texts_colour
    : '#ffffff';
  const buttonLink = primary.button_link ? primary.button_link : '';

  return (
    <>
      <div className="aux_page wrapper">
        <img draggable="false"  src={imageUrl} alt="image_desktop" className="image_desktop" />
        <img draggable="false"  src={imageMobile} alt="image_mobile" className="image_mobile" />

        <div className="banner_information">
          <h1>{title}</h1>
          <p>{description}</p>

          {buttonLink && (
            <Link href={buttonLink}>
              <div href={buttonLink} className="button_container">
                <button type="button" className="two_column_button">
                  {buttonTexts}
                </button>
                <div className="arrow_right">
                  <img draggable="false"  src="https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon_arrow_5.png?v=1714047897" alt="arrow_right" />
                </div>
              </div>
            </Link>
          )}
        </div>
      </div>
      <style jsx>
        {`
          .aux_page {
            width: 100%;
            background: #000000;
            position: relative;
          }
          .aux_page img {
            width: 100%;
          }
          .banner_information {
            position: absolute;
            left: 10%;
            top: 16%;
          }
          .banner_information h1 {
            color: ${titleColour};
            font-family: 'big_noodle_titling';
            font-size: 39px;
            letter-spacing: 0;
            line-height: 48px;
          }
          .banner_information p {
            width: 480px;
            color: ${descriptionColour};
            font-family: 'Roboto-Medium';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
            margin: 0;
            margin-bottom: 30px;
          }
          .button_container {
            display: flex;
            width: 100%;
            display: flex;
            // justify-content: center;
            margin-top: 20px;
          }
          .button_container:hover > .two_column_button {
            background: #800006;
          }
          .button_container:hover > .arrow_right {
            background: #141414;
          }
          .two_column_button {
            height: 48px;
            min-width: 128px;
            color: ${buttonTextsColour};
            background: #950810;
            font-family: 'Roboto-Medium';
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 24px;
            border-radius: 3px 0 0 3px;
            border: none;
            outline: 0;
            padding: 12px 24px;
            text-transform: uppercase;
          }
          .arrow_right {
            width: 48px;
            height: 48px;
            background: #242424;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            border-radius: 0px 3px 03px 0px;
          }
          .arrow_right img {
            width: 25px;
          }
          @media (max-width: ${breakPoints.medium}) {
            .aux_page {
              min-height: 400px;
            }
            .banner_information {
              position: static;
            }
            .banner_information h1 {
              font-size: 26px;
              text-align: center;
            }
            .banner_information p {
              width: 90%;
              text-align: center;
              margin: 0 auto;
            }
            .button_container {
              width: 90%;
              margin: 0 auto;
              margin-top: 20px;
            }
            .button_container button {
              width: 100%;
            }
            .image_desktop {
              display: none;
            }
          }
          @media (min-width: ${breakPoints.medium}) {
            .image_mobile {
              display: none;
            }
          }
        `}
      </style>
    </>
  );
};

export default AuxBanner;
